<template>
  <div>
    <div class="e-sign-banner banner-div row">
      <div class="col-sm-1  col-md-1"></div>
      <div class="bannerDiv col-sm-4 col-md-4">
        <br />
        <h3 class="bannerDivone">App 分发托管</h3>
        <br />
        <h6 class="bannerDivtwo">您只需将需要内测的应用上传至{{_Global.APP_NAME}}</h6>
        <p class="bannerDivtwo"></p>
        <h6>平台自动生成下载短链接和二维码</h6>
        <p class="bannerDivtwo"></p>
        <h6>内测用户通过在手机上扫描二维码，即可将内测应用安装至手机等设备中进行测试。</h6>
        <br />
        <br />
        <el-button style="width:10em" @click="publishApp">发布应用</el-button>
      </div>
      <div class=" col-sm-6 col-md-6">
        <img class="banner-img" src="../assets/img/fenfa_banner.png" />
      </div>
      <div class="bannerDiv col-sm-1 col-md-1"></div>
    </div>
    <div class="module-inner">
      <br />
      <div class="actions-box">
        <h2>功能介绍</h2>
        <br />
        <br />
        <div class="list row">
          <div class="item col-sm-3">
            <img src="../assets/img/superiority_pic3.png" alt="">
            <p></p>
            <h6>应用二合一</h6>
            <p>应用合并后使用统一分发短链接</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/superiority_pic1.png" alt="">
            <p></p>
            <h6>安全稳定</h6>
            <p>提供 7*24 小时应用内测分发服务</p>
          </div>
          <div class="item col-sm-3">
            <img src="../assets/img/superiority_pic2.png" alt="">
            <p></p>
            <h6>高效分发</h6>
            <p>扫描二维码后即可自动识别适配应</p>
          </div>

          <div class="item col-sm-3">
            <img src="../assets/img/superiority_pic4.png" alt="">
            <p></p>
            <h6>高速CDN下载</h6>
            <p>保证全国各地都能享受畅通无阻的下载体验</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    publishApp: function() {
      this.$router.push("/apps");
    }
  },
  components: {}
};
</script>

<style scoped>
.item img {
  height: 6em;
}

.e-sign-banner {
  background-image: url("../assets/img/fenfa_banner_bg.png");
}

@media (max-width: 768px) {
  .banner-img {
    margin-top: 2em;
    height: 16em;
  }
  .e-sign-banner {
    height: 53em;
  }
}

@media only screen and (min-width: 1200px) {
  .banner-img {
    margin-top: 6em;
    height: 25em;
    width: 35em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Fenfa.vue